const baseColors = {
    white: '#FFFFFF',
    green: '#006560',
    lightGray: '#F2F2F2',
    red: '#FF3939',
    gray: '#A3A3A3',
    blue: '#3E78AA',
};

const gradients = {
    green: "linear-gradient(86deg, #006560 0%, #416B49 100%)",
    greenHover: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(86deg, #006560 0%, #416B49 100%)"
};

/**
 * @returns retorna um objeto com cores padrões.
 * @param {String} cor string com o nome da cor
 */
export const GetColors = (cor) => {
    const Color = {
        "gradienteGreen":{
            'background' : gradients.green, 
            'border' : 'none',
            'color': baseColors.white, 
            'hoverbg' : gradients.greenHover, 
            'hovercolor': baseColors.white,  
            'boxShadow': 'none',
        },
        'white-green' : { 
            'background' : baseColors.white, 
            'border' : "2px solid " +baseColors.green,
            'color': baseColors.green, 
            'hoverbg' : baseColors.white, 
            'hovercolor': baseColors.green,  
            'boxShadow': 'none',
        },
        'green-blue' : { 
            'background' : baseColors.white, 
            'border' : "2px solid " +baseColors.green,
            'color': baseColors.green, 
            'hoverbg' : baseColors.lightGray, 
            'hovercolor': baseColors.blue,
            'hoverborder': "2px solid " + baseColors.blue,
            'boxShadow': 'none',
        },
        'green' : { 
            'background' : baseColors.white, 
            'border' : "2px solid " +baseColors.green,
            'color': baseColors.green, 
            'hoverbg' : baseColors.green, 
            'hovercolor': baseColors.white,  
            'boxShadow': 'none',
        },
        'white-red' : {
            'background' : baseColors.white,
            'border' : "2px solid " +baseColors.red,
            'color': baseColors.red,
            'hoverbg' : baseColors.white,
            'hovercolor': baseColors.red,
            'boxShadow': 'none',
        },
        'disabled' : {
            'background' : baseColors.gray,
            'border' : "2px solid " +baseColors.gray,
            'color': baseColors.white,
            'hoverbg' : baseColors.gray,
            'hovercolor': baseColors.white,
            'boxShadow': 'none',
        },
        'transparent' : {
            'background' : 'transparent',
            'border' : 'none',
            'color': baseColors.green,
            'boxShadow': 'none',
        }
    }
    if(!Color[cor]) return{
        'background' : baseColors.gray,
        'border' : "2px solid " + baseColors.gray,
        'color': baseColors.white,
        'hoverbg' : baseColors.gray,
        'hovercolor': baseColors.white,
        'boxShadow': 'none',
    };
    return Color[cor];
};

/**
 * @returns retorna a cor de acordo com o status recebido.
 * @param {Number} status
 */
export const GetCardsColor = (cor, status) =>{
    const colors = {
        0 : {
            background : '#3C9',
            ball : '#2C8D6D',
            border: '2px solid #3C9',
            status: 0,
        },
        1 : {
            background : '#EABC1A',
            ball : '#AD8B15',
            border: '2px solid #EABC1A',
            status: 1,
        },
        2 : {
            background : '#FF3939',
            ball : '#C02A2A',
            border: '2px solid #FF3939',
            status: 2,
        },
        3 : {
            background : '#6600CC',
            ball : '#6600CC',
            border: '2px solid #6600CC',
            status: 3,
        },
        4 : {
            background : '#E1800E',
            ball : '#E1800E',
            border: '2px solid #E1800E',
            status: 4,
        },
        
        5 : {
            background : 'gray',
            ball : 'gray',
            border: '2px solid gray',
            status: 5,
        },
        6 : {
            background : status?"#08928B":"#3E78AA",
            ball : status?"#08928B":"#3E78AA",
            border: status?"#08928B":"#3E78AA",
            status: 0,
        },
    }
    if((cor || cor === 0 || cor === '0') && cor < 7){
        return colors[parseInt(cor)];
    }else{
        return colors[5];
    }
}